import React, { useState } from 'react';
import { Wrapper, Text, Icon, Icons, MobIcon } from './styled';
import { icons, iconOpen } from './icons';

const ShareInSocial = ({ className, title, description, image, url }) => {

    const [active, setActive] = useState(false);

    const onClickIcon = (event, type) => {
        event.stopPropagation();
        let shareLink = '';
        switch (type) {
            case 'facebook':
                shareLink = `https://www.facebook.com/sharer/sharer.php?u=${url}&image=${image}&title=${title}&description=${description}`;
                break;
            case 'google':
                shareLink = `https://plus.google.com/share?url=${url}`;
                break;
            case 'ok':
                shareLink = `http://www.odnoklassniki.ru/dk?st.cmd=addShare&st.s=1&st._surl=${url}&st.comments=${title}&image=${image}`;
                break;
            case 'vk':
                shareLink = `http://vk.com/share.php?url=${url}&title=${title}&description=${description}&image=${image}&noparse=true`;
                break;
        }
        const params = 'scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=0,height=0,left=-1000,top=-1000';
        if (shareLink) {
 window.open(shareLink, 'Поделиться', params);
}
    };

    return (
        <Wrapper className={className} onClick={() => setActive(!active)}>
            <MobIcon active={active} dangerouslySetInnerHTML={{ __html: iconOpen }} />
            <Text>Поделиться:</Text>
            <Icons active={active}>
                {
                    icons.map(item => (
                        <Icon
                            type={item.type}
                            key={item.type}
                            dangerouslySetInnerHTML={{ __html: item.svg }}
                            onClick={event => onClickIcon(event, item.type)}
                        />
                    ))
                }
            </Icons>
        </Wrapper>
    );
};

export default ShareInSocial;
